<fc-progress-bar currentStep="3"></fc-progress-bar>
<div class="container">
  <header class="page-header">
    <div class="fc-back-link" data-cy="button-back" [routerLink]="['/site', activeSite?.id, 'map-site']">
      <fa-icon [icon]="['far', 'arrow-left']" class="gray"></fa-icon>
      <span>Back</span>
    </div>
    <ng-container *ngIf="availableCohorts.length === 1; else chooseBuyer">
      <div class="header-text">Offer Details</div>
      <div class="subheader">Please review the terms below for your offer before continuing.</div>
      <mat-divider></mat-divider>
    </ng-container>
    <ng-template #chooseBuyer>
      <div class="header-text">Available Offers and Terms</div>
      <div class="subheader">
        There are {{ availableCohorts.length }} options available for your selected stands. Please review terms below
        and select an offer to continue.
      </div>
      <mat-divider></mat-divider>
    </ng-template>
  </header>

  <div class="content-container">
    <div class="buyer-cards">
      <ng-container *ngFor="let cohort of availableCohorts">
        <fc-buyer-card
          [site]="activeSite"
          [cohort]="cohort"
          [selectedCohort]="selectedCohort"
          (buyerSelected)="selectCohort(cohort)"></fc-buyer-card>
      </ng-container>
    </div>
    <div class="next-button-container">
      <button
        (click)="onSubmit()"
        [disabled]="!selectedCohort"
        mat-raised-button
        color="primary"
        data-cy="select-offer-next-button">
        Next
      </button>
    </div>
  </div>
</div>
